import type { AppState, MutationClass } from '../../../models'

export class AddPlayedAnimationMutation implements MutationClass {
  static execute(this: void, state: AppState, animationId: string): void {
    if (!state.playedAnimations.includes(animationId)) {
      state.playedAnimations.push(animationId)
    }
  }
}
